import { Component } from '@angular/core';

@Component({
    selector: 'cw-brand-bar',
    templateUrl: './brand-bar.component.html',
    standalone: false,
})
export class BrandBarComponent {}
